import React, { useState } from "react";

const Career = () => {

  const openings = [
    {
      title: "Frontend Developer",
      type: "Full Time",
      location: "Remote / Ludhiana",
      desc: "We are looking for a React.js developer with strong UI/UX understanding.",
    },
    {
      title: "Digital Marketing Executive",
      type: "Full Time",
      location: "Ludhiana",
      desc: "Handle SEO, social media campaigns and online brand growth.",
    },
    {
      title: "UI/UX Designer",
      type: "Internship",
      location: "Remote",
      desc: "Create modern and user-friendly designs for web and mobile apps.",
    },
  ];

  const [selectedJob, setSelectedJob] = useState(null);
  const [success, setSuccess] = useState(false);
  const [form, setForm] = useState({
    name: "",
    email: "",
    experience: "",
    message: "",
    file: null,
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleFile = (e) => {
    setForm({ ...form, file: e.target.files[0] });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!form.name || !form.email) {
      alert("Please fill required fields");
      return;
    }

    setSuccess(true);

    setTimeout(() => {
      setSuccess(false);
      setSelectedJob(null);
      setForm({
        name: "",
        email: "",
        experience: "",
        message: "",
        file: null,
      });
    }, 2000);
  };

  return (
    <div className="bg-[#f9fafb] min-h-screen">

      {/* HERO */}
      <div className="relative h-[60vh] flex items-center justify-center text-center">

        <img
          src="https://images.pexels.com/photos/3184465/pexels-photo-3184465.jpeg"
          className="absolute w-full h-full object-cover"
        />

        <div className="absolute inset-0 bg-black/60"></div>

        <div className="relative text-white max-w-2xl px-6">
          <h1 className="text-4xl md:text-5xl font-bold">Join Our Team</h1>
          <p className="mt-4 text-gray-200">
            Build your career with OM Internet Services
          </p>
        </div>
      </div>

      {/* JOBS */}
      <div className="max-w-6xl mx-auto px-6 py-20">

        <h2 className="text-3xl font-bold text-center mb-12">
          Current Openings
        </h2>

        <div className="space-y-8">

          {openings.map((job, i) => (
            <div key={i} className="bg-white p-6 rounded-2xl shadow-md flex justify-between items-center">

              <div>
                <h3 className="text-xl font-bold">{job.title}</h3>
                <p className="text-gray-500">{job.desc}</p>
                <p className="text-sm text-gray-400 mt-2">
                  📍 {job.location} • 🕒 {job.type}
                </p>
              </div>

              <button
                onClick={() => setSelectedJob(job)}
                className="px-6 py-2 bg-red-600 text-white rounded-full hover:bg-red-700"
              >
                Apply Now
              </button>

            </div>
          ))}

        </div>
      </div>

      {/* MODAL */}
      {selectedJob && (
        <div
          onClick={() => setSelectedJob(null)}
          className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center p-4 z-[9999]"
        >

          <div
            onClick={(e) => e.stopPropagation()}
            className="bg-white w-full max-w-md rounded-2xl p-6 relative"
          >

            <h2 className="text-xl font-bold mb-4">
              Apply for {selectedJob.title}
            </h2>

            {/* SUCCESS MESSAGE */}
            {success && (
              <div className="mb-4 p-3 bg-green-100 text-green-700 rounded-lg animate-pulse">
               Application Submitted Successfully!
              </div>
            )}

            <form onSubmit={handleSubmit} className="space-y-4">

              <input
                type="text"
                name="name"
                placeholder="Your Name"
                value={form.name}
                onChange={handleChange}
                className="w-full p-3 border rounded-xl"
                required
              />

              <input
                type="email"
                name="email"
                placeholder="Your Email"
                value={form.email}
                onChange={handleChange}
                className="w-full p-3 border rounded-xl"
                required
              />

              <input
                type="text"
                name="experience"
                placeholder="Experience"
                value={form.experience}
                onChange={handleChange}
                className="w-full p-3 border rounded-xl"
              />

              {/* FILE UPLOAD */}
              <input
                type="file"
                onChange={handleFile}
                className="w-full p-2 border rounded-xl"
              />

              <textarea
                name="message"
                placeholder="Why should we hire you?"
                value={form.message}
                onChange={handleChange}
                className="w-full p-3 border rounded-xl"
                rows="4"
              />

              <button
                type="submit"
                className="w-full bg-red-600 text-white py-3 rounded-xl hover:bg-red-700"
              >
                Submit Application
              </button>

              <button
                type="button"
                onClick={() => setSelectedJob(null)}
                className="w-full text-gray-500 mt-2"
              >
                Cancel
              </button>

            </form>

          </div>
        </div>
      )}

    </div>
  );
};

export default Career;